export enum EnergyType {
    Both = 'both',
    Electricity = 'electricity',
    Gas = 'gas',
    None = 'none', // This is a special case for the energy type, it means that the user doesn't want to share their energy type. If this would be the case, we won't set the default to 'both' in the run-before-create.handler
}
